<template>
  <v-container
    fluid
    fill-height
    class="main--text">
    <v-row
      v-for="(teacherId, index) in parent.getTeacherIds()"
      :key="index"
      justify=center
      align=center>
      <v-col
        cols=auto>
        <v-btn
          class="font-weight-bold"
          x-large
          color="primary"
          dark
          @click="toEditor(index)"
          ><span>エディタルームに<br>入室する</span></v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VEditor from '@/components/organisms/editor/VEditor'
export default {
  components: {
    VEditor,
  },
  data () {
    return {
      parent: this.$store.getters.parent
    }
  },
  methods: {
    toEditor (index) {
      this.$router.push({name: 'parentEditor', params: { id: this.parent.getId(), index: index}})
    }
  },
  created () {

  }
}
</script>
